import React from 'react'
import {Row, Col, Button, Typography, Space} from 'antd';
import { Icon } from '@ant-design/compatible';

import {OrderService} from "../../../shared/services/OrderService";
import {isBackOfficeOrUpgasEmployee, isUserResale} from "../../../shared/services/UserService";
import OrderStatusEnum from "../../../shared/Enum/OrderStatusEnum";

const ResumoDetalhePedido = ({order}) => {
  const {statusId} = order
  const isRequested = statusId === OrderStatusEnum.Solicitado
  const isInProgress = statusId === OrderStatusEnum.AceitoPelaOrganizacao || statusId === OrderStatusEnum.AceitoPeloMotorista

  return (
    <div>
      <Row type="flex" justify="space-between" align="middle" className="mt-10">
        <Col>
          <Typography.Title level={2} className="mb-0">Resumo do pedido</Typography.Title>
        </Col>
        <Col>
          <Button type="primary" ghost onClick={() => OrderService().copyToClipboard(order)}>
            <Icon type="copy" theme="filled"/>
            <span>Copiar pedido</span>
          </Button>
        </Col>
      </Row>

      <Row type={"flex"} gutter={14}>
        <Col>
          <Icon type="user"/>
        </Col>
        <Col>
          <Typography.Text strong>{order.customer.name}</Typography.Text>
          <Typography.Text type="secondary">
            <span style={{ color: "#aaa", marginLeft: 6 }}>
                ({order.customer.totalOrders} pedidos)
            </span>
          </Typography.Text>
        </Col>
      </Row>

      <Row type={"flex"} gutter={14}>
        {(order.customer.phone || (isBackOfficeOrUpgasEmployee() && order.customer.originalPhone)) && (
          <Col>
            <Row type={"flex"} gutter={14}>
              <Col>
                <Icon type="phone"/>
              </Col>
              <Col>
                {(() => {
                  const phoneToDisplay = isBackOfficeOrUpgasEmployee()
                    ? order.customer.originalPhone
                    : order.customer.phone;
                  return <Typography.Text>{phoneToDisplay}</Typography.Text>;
                })()}
              </Col>
            </Row>
          </Col>
        )}
        {order.customerFiscalNoteDocument !== "" && (
          <Col>
            <Typography.Text>CPF na nota: {order.customerFiscalNoteDocument}</Typography.Text>
          </Col>
        )}
      </Row>

      <Space align="start" gutter={14}>
        <Icon type="environment"/>
        <Typography.Text>{order.customer.address}</Typography.Text>
        {order.customer.complement && <Typography.Text>{order.customer.complement}</Typography.Text>}
      </Space>

      {(order.codigoConfirmacao && isBackOfficeOrUpgasEmployee()) && (
        <Row>
          <Typography.Text>Código Confirmação: {order.codigoConfirmacao}</Typography.Text>
        </Row>
      )}
    </div>
  )
}

export default ResumoDetalhePedido
